import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { LoanOfficerDetail, LoanOfficerDomain, applicationApi } from "pages/application/applicationService";
import type { RootState } from "store";

const initialState: {
  loanOfficerDetail: LoanOfficerDetail | null;
} = {
  loanOfficerDetail: null
};

export const loanOfficerSlice = createSlice({
  name: "loanOfficer",
  initialState,
  reducers: {
    setLoanOfficerDetail: (state, action: PayloadAction<LoanOfficerDetail>) => {
      state.loanOfficerDetail = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(applicationApi.endpoints.getloanOfficer.matchFulfilled, (state, action: PayloadAction<LoanOfficerDetail>) => {
      state.loanOfficerDetail = action.payload;
    });
  },
});

export const { setLoanOfficerDetail } = loanOfficerSlice.actions;

export const getLoanOfficerDetail = (state: RootState): LoanOfficerDetail | null => state.loanOfficer.loanOfficerDetail;
export const getLoanOfficerPrimaryDomain = (state: RootState): LoanOfficerDomain | null => {
  const domains = state.loanOfficer.loanOfficerDetail?.domains;
  return domains && domains.length > 0 ? domains[0] : null;
};
export const getLoanOfficerDomainName = (state: RootState): string => {
  const primaryDomain = getLoanOfficerPrimaryDomain(state);
  return primaryDomain?.domainName?.toLowerCase() ?? "";
};

export default loanOfficerSlice.reducer;
